<template>
  <div id="mallIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">商城</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
// 页面二级菜单
import SecondMenu from "components/layout/SecondMenu";
export default {
  components: {
    SecondMenu
  },
  data() {
    return {
      secondaryMenuMap: [
        {
          menuName: "商城管理",
          url: "mall-manage",
          childrenMenu: [
            {
              name: "导航栏",
              url: "/admin/mall/mall-top",
              keyword: "ROLE_TOP"
            },
            {
              name: "菜单栏",
              url: "/admin/mall/mall-side",
              keyword: "ROLE_LEFT"
            },
            {
              name: "信息栏",
              url: "/admin/mall/mall-bottom",
              keyword: "ROLE_BOTTOM"
            }
          ]
        },
        {
          menuName: "手机装修",
          url: "/admin/mall/phone-decorate",
          keyword: "ROLE_MALL_h5",
          childrenMenu: []
        },
        {
          menuName: "客服设置",
          url: "/admin/mall/customer-service",
          keyword: "ROLE_MALL_service_setting",
          childrenMenu: []
        },
        {
          menuName: "自定义页面",
          url: "/admin/mall/phone-customize",
          keyword: "ROLE_MALL_service_setting11",
          childrenMenu: []
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
<style lang="scss">
.secondary-menu-container {
  .secondary-menu-title {
    height: 40px;
    line-height: 40px;
    color: rgba(48, 49, 51, 1);
    font-weight: 500;
    letter-spacing: 1px;
    width: 120px;
    text-align: center;
  }
}
</style>
